import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UserPromoteToPartner } from 'types/api'
import { BaseParams } from 'types/utils'

interface DemotePartnerResponse {
  success: boolean
  message: string
  user: {
    id: string
    email: string
    role: string
  }
}

export function useDemotePartner() {
  const queryClient = useQueryClient()

  async function demotePartner({
    id,
    body
  }: BaseParams<[UserPromoteToPartner, DemotePartnerResponse], 'POST'>) {
    const response = await apiClient.post<DemotePartnerResponse>(
      `${SNA_PREFIX}partners/${id}/demote`,
      body
    )
    return response.data
  }

  return useMutation({
    mutationFn: demotePartner,
    onSuccess: (data, variables) => {
      variables.params?.onSuccess?.(data)
      // Invalidate partner list to refresh data
      queryClient.invalidateQueries({ queryKey: ['partners'] })
      // Also invalidate all partner-related queries
      queryClient.invalidateQueries({
        predicate: (query) =>
          Array.isArray(query.queryKey) && query.queryKey[0] === 'partners'
      })
    },
    onError: (_, variables) => {
      variables.params?.onError?.()
    }
  })
}
